import React, { useState, useEffect } from "react"
import { getRecentTrips } from "../../../../utils/recentSearches"

const TRIP_LABELS = { 1: "Local", 2: "Rental", 3: "Outstation" }
const PKG_DISPLAY = { "4": "4 hrs", "6": "6 hrs", "8": "8 hrs", "12": "12 hrs" }

const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
)

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, opacity: 0.6 }}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
)

const getChipText = (trip) => {
  if (trip.trip_type === 2) {
    const pkgLabel = PKG_DISPLAY[trip.package] || (trip.package ? `${trip.package} hrs` : "")
    return pkgLabel ? `${trip.fromCity} · ${pkgLabel}` : trip.fromCity
  }
  return null // handled with arrow inline
}

const RecentSearchChips = ({ onSelect }) => {
  const [trips, setTrips] = useState([])

  useEffect(() => {
    setTrips(getRecentTrips().slice(0, 2))
  }, [])

  if (trips.length === 0) return null

  return (
    <div className="recent-searches">
      <span className="recent-searches__label">Recent</span>
      <div className="recent-searches__chips">
        {trips.map((trip, i) => (
          <button
            key={i}
            type="button"
            className="recent-searches__chip"
            onClick={() => onSelect(trip)}
            title={`Re-search ${trip.fromCity}${trip.toCity ? ` → ${trip.toCity}` : ""}`}
          >
            <ClockIcon />
            {trip.trip_type !== 2 ? (
              <span className="recent-searches__chip-route">
                <span className="recent-searches__chip-city">{trip.fromCity}</span>
                <ArrowIcon />
                <span className="recent-searches__chip-city">{trip.toCity}</span>
              </span>
            ) : (
              <span className="recent-searches__chip-route">
                {getChipText(trip)}
              </span>
            )}
            <span className="recent-searches__chip-tag">
              {TRIP_LABELS[trip.trip_type]}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default RecentSearchChips
